import React from 'react'

const Form = function form (){
    return (    
        <main>
            <div className="back flex w90">
            <a href={https} className="flex">
                <img src={https+"img/back.svg"} alt="⬅"/>
                <span>Atrás</span>
            </a>
            </div>

            <img src={https+"/img/banner2.jpg"} alt="user-banner" className="userBanner dnone"/>

            <section className="login">
                <div className="container colflex w90">
                    <h3>
                        <br/>
                        Datos de compra y despacho
                        <br/>
                        <br/>
                    </h3>
                    <input type="text" placeholder="Ingresa tu Nombre"/>
                    <input type="text" placeholder="Ingresa tu Apellido"/>
                    <input type="text" placeholder="Ingresa tu Cedula"/>
                    <input type="text" placeholder="Ingresa tu Correo Electronico"/>
                    <input type="password" placeholder="Ingresa tu Contraseña"/>
                    <input type="text" placeholder="Ingresa tu Telefono"/>
                    <input type="text" placeholder="Ingresa tu Direccion"/>
                    <select>
                        <option>Selecciona tu Pais</option>  
                    </select>
                    <select>
                        <option>Selecciona tu Departamento</option>  
                    </select>
                    <select>
                        <option>Selecciona tu Ciudad</option>  
                    </select>
                    <input type="text" placeholder="Ingresa tu Barrio"/>
                    <a href="profile.html" className="loginMob2">
                        Ir a pagar
                    </a>
                </div>
            </section>

        </main>
    )
}

export default Form